__turbopack_context__.v({
  "embed_modal": "_14i-zG_embed_modal",
  "embed_modal__btn_close": "_14i-zG_embed_modal__btn_close",
  "embed_modal__copy_button": "_14i-zG_embed_modal__copy_button",
  "embed_modal__dialog": "_14i-zG_embed_modal__dialog",
  "embed_modal__edit_dimensions": "_14i-zG_embed_modal__edit_dimensions",
  "embed_modal__iframe_title": "_14i-zG_embed_modal__iframe_title",
  "embed_modal__image": "_14i-zG_embed_modal__image",
  "embed_modal__info": "_14i-zG_embed_modal__info",
  "embed_modal__input_button": "_14i-zG_embed_modal__input_button",
  "embed_modal__meta": "_14i-zG_embed_modal__meta",
  "embed_modal__show_title": "_14i-zG_embed_modal__show_title",
  "embed_modal__text_for_copying": "_14i-zG_embed_modal__text_for_copying",
  "embed_modal__topbar": "_14i-zG_embed_modal__topbar",
  "embed_modal__topbar_title": "_14i-zG_embed_modal__topbar_title",
  "embed_modal__video_title": "_14i-zG_embed_modal__video_title",
  "embed_window__content": "_14i-zG_embed_window__content",
});
